import { memoryDto } from '../dto/memoryDto';
import { tableViewModel } from '../views/tableViewModel';

export class MemoryTransformer {
  public static from(memory: memoryDto): tableViewModel[] {
    return <tableViewModel[]>[
      {
        name: 'Provisioned Memory',
        value:
          memory.provisionedMemory == null
            ? '-'
            : (memory.provisionedMemory).toFixed(2) + ' GiB'
      },
      {
        name: 'Active Memory',
        value:
          memory.activeMemory == null
            ? '-'
            : (memory.activeMemory).toFixed(2) + ' GiB'
      },
      {
        name: 'Physical to Active Ratio',
        value:
          memory.activeToPhysicalMemoryRatio == null
            ? '-'
            : memory.activeToPhysicalMemoryRatio.toString()
      },
      {
        name: 'Host Consumed Memory',
        value:
          memory.consumedMemoryOnHosts == null
            ? '-'
            : (memory.consumedMemoryOnHosts).toFixed(2) + ' GiB'
      }
    ];
  }
}
